import { render } from "./sharePlex.vue?vue&type=template&id=64a1815f&lang=true"
import script from "./sharePlex.vue?vue&type=script&lang=js"
export * from "./sharePlex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__